import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GridBase } from './grid.base';

export declare type Alignment = 'stretch'|'center'|'flex-start'|'flex-end'|'baseline';

export declare type Justification = 'flex-start'|'flex-end'|'center'|'space-between'|'space-around'|'space-evenly';


@Component({
  selector: 'app-row',
  template: `<ng-content></ng-content>`,
  styles: [`
    :host[align]:not(.text-center) {
      text-align: initial;
    }
    :host.no-wrap {
      flex-wrap: nowrap;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowComponent extends GridBase {
  @Input() direction: 'row'|'column' = 'row';
  @Input() align: Alignment;
  @Input() justify: Justification;
  @Input() gutter: 'xs'|'sm'|'lg'|'x-xs'|'x-sm'|'x-lg'|'y-xs'|'y-sm'|'y-lg';
  @Input() wrap: boolean|'true'|'false' = true;

  calculateClassList(): void {
    const row = this.direction || 'row';
    const align = this.align ? `align-${this.align}` : '';
    const justify = this.justify ? `justify-${this.justify}` : '';
    const [size, dir] = this.gutter ? this.gutter.split('-').reverse() : [];
    const gutter = dir ? `g${dir}-${size}` : `g-${size}`;
    const wrap = (typeof this.wrap === 'boolean' && this.wrap)
    || (typeof this.wrap === 'string' && this.wrap.toLowerCase() === 'true')
      ? '' : 'no-wrap';

    this.classList$.next([row, align, justify, gutter, wrap].filter(c => !!c));
  }
}
